<!-- This will only show if embed shell tour has already been dismissed - otherwise, this is covered by the shell tour -->
@if (shellTourCompleted$ | async) {
    <adapt-dismissible-cta class="d-none d-md-contents"
                           [flag]="PersonFlag.AiTourDismissed"
                           (dismissCta)="onDismiss($event)">
        <h1 adapt-cta-title>Discover the power of Lumia Assistant.</h1>

        <button adapt-cta-action
                data-tour="personal-dashboard-tour-cta"
                class="btn btn-primary px-4"
                (click)="runTour()">
            Start tour
            <i class="fal fa-fw fa-arrow-right ms-2"></i>
        </button>

        <div>
            Take a moment to explore the <b>Lumia Assistant</b>!
            <br />
            Completing the tour will show you how it can enhance your experience and help you navigate the platform effortlessly.
        </div>
    </adapt-dismissible-cta>
}
